// extracted by mini-css-extract-plugin
export default {"bg":"BackgroundTop_bg__S8Zky","light":"BackgroundTop_light__PjkuC","dark":"BackgroundTop_dark__mpd+R"};